import styled from "styled-components";
import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const StepsContainer = styled(FlexColumn)`
    padding: 0 8px 8px 8px;
    gap: 8px;
    align-items: center;
`;

export const ActivationWizardWrapper = styled.div`
    width: 100%;
`;
export const HeaderActivationWizard = styled(FlexRow)`
    width: 100%;
    justify-content: space-between;
`;
export const LoaderWrapper = styled.div`
    width: 100%;
    gap: 24px;
`;
export const LoaderSuggestedWrapper = styled(FlexColumn)`
    width: 100%;
    gap: 12px;
`;
